<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header"
      [afTranslate]="'channel-configuration.qr-code'">Código QR</span>
  </div>
  <!-- Contenedor -->
  <p class="common-modal__content-header-info"
    [afTranslate]="'channel-configuration.qr-info'">Escanea este código QR para acceder directamente a la URL pública.</p>
  <qrcode class="qr-modal__qr-code-container"
    [qrdata]="url"
    [cssClass]="'center'"
    [colorDark]="colorQR"
    [colorLight]="'#ffffff'"
    [elementType]="'svg'"
    [errorCorrectionLevel]="'M'"
    [margin]="0"
    [scale]="1"
    [width]="200"></qrcode>
  <!-- Footer botonera -->
  <div class="common-modal__footer">
    <button class="common-button__text-border"
      (click)="handleDismiss()">
      <span class="common-button__text-title"
        [afTranslate]="'common.cancel'">_Cancelar</span>
    </button>
    <button class="common-button__text"
      (click)="downloadQR()">
      <span class="common-button__text-title"
        [afTranslate]="'expanded-menu.download'">_Descargar</span>
    </button>
  </div>
</div>
